export const SET_CHANNELS_CUSTOMERS = "SET_CHANNELS_CUSTOMERS ";
export const SET_WEBHOOK_PROVIDER_WHATSAPP = " SET_WEBHOOK_PROVIDER_WHATSAPP";
export const ADD_CHANNEL = "ADD_CHANNEL";
export const REMOVE_CHANNEL = "REMOVE_CHANNEL";
export const SET_CHANNEL = "SET_CHANNEL";
export const SET_DATA_PARAMETERS = "SET_DATA_PARAMETERS";
